/* Filter Object Structure
{
    value:
    definition: {
        id:
        title:
        type:
        defaultValue:
        availableValues:
        availableValuesLocation:
        fixed:
    }
}
*/

import PropTypes from 'prop-types';

const stringPropType = PropTypes.string;

const numberPropType = PropTypes.number;

const datePropType = PropTypes.shape({
    to: PropTypes.string,
    from: PropTypes.string,
    today: PropTypes.bool
});

const numberRangePropType = PropTypes.shape({
    to: PropTypes.number,
    from: PropTypes.number
});

const listPropType = PropTypes.arrayOf(
    PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([
            stringPropType,
            numberPropType
        ])
    })
);

const listValuePropType = PropTypes.arrayOf(
    PropTypes.string
);

const anyTypePropType = PropTypes.oneOfType([
    stringPropType,
    numberPropType,
    datePropType,
    listValuePropType,
    numberRangePropType
]);

export const filterDefinitionPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    defaultValue: anyTypePropType,
    availableValues: listPropType,
    availableValuesLocation: PropTypes.string,
    fixed: PropTypes.bool
});

export const filterDefinitionsPropType = PropTypes.arrayOf(filterDefinitionPropType);

export const filterPropType = PropTypes.shape({
    definition: filterDefinitionPropType.isRequired,
    value: anyTypePropType
});

export const filtersPropType = PropTypes.arrayOf(filterPropType);

export const filterTypes = {
    string: 'string',
    date: 'date',
    number: 'number',
    list: 'list',
    radioList: 'radioList',
    dateFromOnly: 'dateFromOnly',
    dateToOnly: 'dateToOnly'
};
